import { connectCustom } from "@client/lib/misc";

import { type RootContainerProps } from "@client/content/types";
import { type AppState } from "@client/types";
import Component, { type ComponentProps } from "./component";
import { makeStyleSelector } from "./selectors";

const makeMapStateToProps = () => {
  const styleSelector = makeStyleSelector();

  return (state: AppState, props: RootContainerProps): ComponentProps => {
    return {
      ...props,
      style: styleSelector(state, props)
    };
  };
};

export default connectCustom(makeMapStateToProps)(Component);
